import React from "react";

function RefundPolicy() {
  return (
    <div className="min-h-screen bg-gray-50 py-10 px-6">
      <div className="max-w-3xl mx-auto bg-white shadow-md rounded-lg p-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-6 border-b pb-4">
          Refund Policy
        </h1>

            <section className="mb-4">
          <p className="text-gray-700 leading-relaxed">
We will notify you once we’ve received and inspected your return, and let you know if
the refund was approved or not. If approved, you’ll be automatically refunded on your
original payment method within 10 business days. Please remember it can take some
time for your bank or credit card company to process and post the refund too. If more
than 15 business days have passed since we’ve approved your return, please contact
us at <mark>Email: info@vigyanpathshala.com  Phone: +91 8303309334</mark>

          </p>
        </section>
      </div>
    </div>
  );
}

export default RefundPolicy;
